export const MAIN = 'main';
export const BODY = 'body';
export const SKIN = 'skin';

export const SCIENCE_CATEGORY_IDS: Record<string, string> = {
  body: 'science_body',
  skin: 'science_skin',
};
